var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.038,
    height: 104.038,
    viewBox: "0 0 104.038 104.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.308,
    y1: 0.066,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c6c6c",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_27",
    x: 0,
    y: 0,
    width: 104.038,
    height: 104.038,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.761
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Ellipse_27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_27-2",
    "data-name": "Ellipse 27",
    d: "M32.748.39a32.6,32.6,0,0,0-6.522.657,32.179,32.179,0,0,0-11.57,4.869A32.454,32.454,0,0,0,2.933,20.153a32.194,32.194,0,0,0-1.885,6.073,32.678,32.678,0,0,0,0,13.044A32.179,32.179,0,0,0,5.916,50.84,32.454,32.454,0,0,0,20.153,62.564a32.193,32.193,0,0,0,6.073,1.885,32.678,32.678,0,0,0,13.044,0,32.179,32.179,0,0,0,11.57-4.869A32.454,32.454,0,0,0,62.564,45.344a32.193,32.193,0,0,0,1.885-6.073,32.678,32.678,0,0,0,0-13.044,32.179,32.179,0,0,0-4.869-11.57A32.454,32.454,0,0,0,45.344,2.933,32.194,32.194,0,0,0,39.27,1.047,32.6,32.6,0,0,0,32.748.39m0-.39A32.748,32.748,0,1,1,0,32.748,32.748,32.748,0,0,1,32.748,0Z",
    transform: "matrix(0.87, -0.48, 0.48, 0.87, 7.5, 39.25)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.0545044fa17d149a2066ea4ba663d97d.svg";
export { ForwardRef as ReactComponent };